import { render } from "./UppMenuCentral.vue?vue&type=template&id=7fd47447"
import script from "./UppMenuCentral.vue?vue&type=script&lang=js"
export * from "./UppMenuCentral.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pulsell/data/www/driver.pulsell.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__